import { gameTypes } from 'config/promoGameTypes';
import { entryVerifyStatus } from 'config/entryVerifyStatus';

export const taskTypes = {
    LOTTERY: 1,
    PROMOTION: 2,
    PRIZE: 3
};

export const taskConditionTypes = {
    BY_PLAY_TIMES: 1,
    BY_PROMO_TYPE: 4,
    BY_FINISH_PROMO_TASK_TIMES: 6,
    BY_INVITE_COUNT: 7,
    BY_ALL_CORRECT_WIN_PRIZE: 9,
    // 多元任務模組: 建立闖關卡
    BY_COMPLETE_TASK_TIMES: 10,
    // 驗收證據或訂單中還有指定品相
    BY_CONDITION_TYPE_RECEIPT_OPTION_MATCH: 11,
    // 驗收 PageId 有指定 Prize
    BY_CONDITION_TYPE_PAGE_MATCH: 12,
    // 多元任務模組: 自訂設定/關卡完成條件 (完成參加 -> 全部答對),
    BY_COMPLETE_All_TASKS: 13,
    // 多元任務模組: 達成邀請條件
    BY_COMPLETE_INVITE_TIMES: 14
};

export const taskCardStatuses = {
    JOIN: 'join',
    LOCK: 'lock',
    CHECK: 'check',
    VERIFY_PENDING: 'verify_pending',
    VERIFY_FAILED: 'verify_failed'
};

export const taskCardStatusMapUgcVerifyStatus = {
    [taskCardStatuses.VERIFY_PENDING]: entryVerifyStatus.WAITING,
    [taskCardStatuses.VERIFY_FAILED]: entryVerifyStatus.NOT_PASS,
    [taskCardStatuses.JOIN]: entryVerifyStatus.PASSED,
    [taskCardStatuses.CHECK]: entryVerifyStatus.PASSED
};

// 建立闖關模組的關卡時，要帶入 創意相框 的 gameType 當 ConditionValue 的參數
export const taskConditionTypesPromoMapping = {
    [gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE]: gameTypes.PHOTO_FRAME_COMPOSITE
};

export const taskSyncTypes = {
    byTarget: 0,
    byAllTasks: 1
};

export const taskDialogStatus = {
    IS_CREATING: 1,
    IS_EDITING: 2
};

export const COMPLETE_TASK_CONDITION_TYPE = {
    haveEntryRecords: 0,
    answerAllCorrectly: 1,
    referralSuccessfully: 2
};

export const cardDisplayModes = {
    VERTICAL: 1,
    HORIZONTAL: 2,
    SQUARE: 3
};
